export default __webpack_public_path__ + "static/media/banner-classkick-pro-users.655ab796.png";